
import {initTiptap, destroyTiptap, getTiptapEditor} from '../common/setupTiptap';
import {Dom} from '../common/util/Dom';

import tippy from 'tippy.js';

let modal;
let background;

function init() {
    modal = document.getElementById('modal-container');
    if (!modal) return;
    modal.emptyContent = modal.innerHTML;
    modal.getTitle = () =>  document.getElementById('modal-title'); 
    modal.getContent = () =>  document.getElementById('modal-content');
    document.body.addEventListener('keydown', (e) => {
        if (e.code == 'Escape') closeModal();
    });
    background = document.getElementById('modal-background');
    if (modal.isInit) return;
    function closeModal() {
        if (!modal.classList.contains('visible')) return;
        background.classList.remove('visible');
        modal.classList.remove('visible');

        // Get content from Tiptap editor and update original element
        const editorInput = modal.getContent().querySelector('.richtext');
        if (editorInput) {
            const editor = getTiptapEditor(editorInput);
            if (editor) {
                modal.currentElement.value = editor.getHTML();
                modal.currentElement.dispatchEvent(new Event('change', { bubbles: true }));
                destroyTiptap(editor);
            }
        }

        modal.innerHTML = modal.emptyContent;
        if (modal.preview) {
            modal.preview.innerHTML = modal.currentElement.value;
            modal.preview.classList.add('preview');
        }
        modal.querySelector('.modal-close').addEventListener('click', () => { closeModal(); });
        modal.querySelector('.modal-validate').addEventListener('click', () => { closeModal(); });
    }
    modal.querySelector('.modal-close').addEventListener('click', () => { closeModal(); });
    modal.querySelector('.modal-validate').addEventListener('click', () => { closeModal(); });
    background.addEventListener('click', () => { closeModal(); });
    modal.isInit = true;
}

export function setupTextModals() {
    init();
    const textModals = document.querySelectorAll('.modal-text');
    textModals.forEach(textModal => {
        setupTextModal(textModal);
    });
}

function setupTextModal(textModal) {
    if (Dom.isTemplate(textModal) || textModal.isInit) return;
    let btnModal = textModal.parentElement;

    const isFeedbackField = textModal.name && textModal.name.includes('feedback');

    if (isFeedbackField) {
        tippy(btnModal, {content: 'Feedback'});
        btnModal.classList.add('modal-clickable-star');
    } else {
        const isInConsultantTable = textModal.name && textModal.name.includes('tasks');
        tippy(btnModal, {content: isInConsultantTable ? 'Tasks' : 'Work done'});
        btnModal.classList.add('modal-clickable-icon');
        // Add FA icon if not already present
        if (!btnModal.querySelector('.fa-clipboard-list, .fa-list-check')) {
            const icon = document.createElement('i');
            icon.className = isInConsultantTable ? 'fas fa-clipboard-list' : 'fas fa-list-check';
            icon.style.pointerEvents = 'none';
            btnModal.insertBefore(icon, btnModal.firstChild);
        }
    }
    
    textModal.isInit = true;
    btnModal.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        showModal(textModal, employeeName(btnModal));
    });
}

function employeeName(elem) {
    const employeeElem = elem && elem.parentElement && elem.parentElement.children[0].querySelector('select');
    return employeeElem.options[employeeElem.selectedIndex].text;
}

export function showModal(textModal, titleModal, previewElement = null) {
    modal.classList.add('visible');
    background.classList.add('visible');
    const input = document.createElement('textarea');
    input.classList.add('richtext');
    input.value = textModal.value || '';
    modal.getTitle().innerHTML = titleModal;
    modal.getContent().appendChild(input);
    modal.currentElement = textModal;
    if (previewElement) modal.preview = previewElement;

    // Initialize Tiptap on the new input
    initTiptap('.richtext', { maxHeight: 400 });
} 